function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import PropTypes from 'prop-types';
import React from 'react';
import striptags from 'striptags';

const withHtmlSafe = WrappedComponent => {
  const HtmlSafeComponent = ({
    children,
    html,
    allowedTags,
    ...remainingProps
  }) => {
    if (html) {
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
        dangerouslySetInnerHTML: {
          __html: striptags(children, allowedTags)
        }
      }, remainingProps));
    }

    return /*#__PURE__*/React.createElement(WrappedComponent, remainingProps, children);
  };

  HtmlSafeComponent.propTypes = {
    children: PropTypes.node.isRequired,
    html: PropTypes.bool,
    allowedTags: PropTypes.arrayOf(PropTypes.string)
  };
  HtmlSafeComponent.defaultProps = {
    html: false,
    allowedTags: ['br', 'p', 'strong', 'a', 'b', 'em', 'i', 'u', 's', 'blockquote', 'ul', 'ol', 'li', 'q', 'cite', 'del', 'ins', 'code', 'abbr', 'sub', 'sup']
  };
  HtmlSafeComponent.displayName = `HtmlSafe(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  return HtmlSafeComponent;
};

export default withHtmlSafe;